import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8fcff 100%);
  border-radius: 24px;
  padding: 3rem 2.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 213, 146, 0.1);
  height: 100%;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 213, 146, 0.05) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: 0;
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -100px;
    right: -100px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(0, 213, 146, 0.08) 0%, transparent 70%);
    border-radius: 50%;
    opacity: 0.5;
    transition: all 0.4s ease;
  }
  
  &:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    border-color: rgba(0, 213, 146, 0.3);
    
    &::before {
      opacity: 1;
    }
    
    &::after {
      transform: translate(-30px, -30px);
    }
  }
`;

const IconContainer = styled.div`
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, ${props => props.theme.colors.primary}, #00a080);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.white};
  font-size: 2rem;
  position: relative;
  box-shadow: 0 10px 20px rgba(0, 213, 146, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    border-radius: 24px;
    border: 2px dashed rgba(0, 213, 146, 0.3);
    opacity: 0;
    transition: opacity 0.3s ease, transform 10s linear;
  }
  
  ${Card}:hover & {
    &::before {
      opacity: 1;
      animation: spin 20s linear infinite;
    }
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Title = styled.h3`
  font-size: 1.4rem;
  margin-bottom: 1.2rem;
  color: ${props => props.theme.colors.secondary};
  position: relative;
  padding-bottom: 0.8rem;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 3px;
    background: ${props => props.theme.colors.primary};
    transition: width 0.3s ease;
  }
  
  ${Card}:hover &::after {
    width: 80px;
  }
`;

const Description = styled.p`
  color: ${props => props.theme.colors.gray};
  font-size: 1rem;
  line-height: 1.6;
  position: relative;
  z-index: 1;
`;

const FeatureCard = ({ icon, title, description }) => {
  return (
    <Card>
      <IconContainer>{icon}</IconContainer>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Card>
  );
};

export default FeatureCard;